import React from "react";
import Card, { CardTitle } from "./Card";
import {
  VictoryBar,
  VictoryChart,
  VictoryAxis,
  VictoryGroup,
  VictoryLabel,
  VictoryLegend,
} from "victory";
import styled from "styled-components";

const Content = styled.div`
  width: 100%;
  text-align: center;
`;

export default function StickinessGraph() {
  const peoplePowerData = [
    { x: "TikTok", y: 1 },
    { x: "Pandora", y: 3 },
    { x: "Hulu", y: 19 },
    { x: "Spotify", y: 7 },
    { x: "Netflix", y: 15 },
    { x: "Instagram", y: 5 },
    { x: "Youtube", y: 13 },
    { x: "Google Search", y: 7 },
    { x: "Facebook", y: 32 },
  ];

  const forTheLolzData = [
    { x: "TikTok", y: 1 },
    { x: "Pandora", y: 5 },
    { x: "Hulu", y: 14 },
    { x: "Spotify", y: 7 },
    { x: "Netflix", y: 18 },
    { x: "Instagram", y: 4 },
    { x: "Youtube", y: 19 },
    { x: "Google Search", y: 6 },
    { x: "Facebook", y: 26 },
  ];

  const toughCookiesData = [
    { x: "TikTok", y: 0 },
    { x: "Pandora", y: 2 },
    { x: "Hulu", y: 12 },
    { x: "Spotify", y: 5 },
    { x: "Netflix", y: 19 },
    { x: "Instagram", y: 7 },
    { x: "Youtube", y: 14 },
    { x: "Google Search", y: 6 },
    { x: "Facebook", y: 24 },
  ];

  const dontTreadOnMeData = [
    { x: "TikTok", y: 2 },
    { x: "Pandora", y: 1 },
    { x: "Hulu", y: 6 },
    { x: "Spotify", y: 7 },
    { x: "Netflix", y: 9 },
    { x: "Instagram", y: 4 },
    { x: "Youtube", y: 11 },
    { x: "Google Search", y: 6 },
    { x: "Facebook", y: 25 },
  ];

  const graphData = [
    { x: "0 mins", y: 0 },
    { x: "10 mins", y: 0 },
    { x: "20 mins", y: 0 },
    { x: "30 mins", y: 0 },
  ];

  var barcount = 0;
  peoplePowerData.map((dataObj) => {
    barcount++;
  });

  const cornerRadius = 2.5;

  return (
    <Card>
      <CardTitle>
        Stickiness: When users visit, how long do they stay?
      </CardTitle>
      <Content>
        <svg viewBox="0 0 650 550">
          {/* Legend */}
          <VictoryLegend
            x={525}
            y={200}
            standalone={false}
            gutter={20}
            fontSize={12}
            colorScale={[
              "#FF99FF", // PP
              "#B3914D", // IYSS
              "#40B5BF", // TC
              "#FF6633", // DTOM
            ]}
            style={{ labels: { fontSize: 12 } }}
            data={[
              {
                name: "People Power",
                symbol: { type: "square" },
              },
              {
                name: "If You Say So",
                symbol: { type: "square" },
              },
              {
                name: "Tough Cookies",
                symbol: { type: "square" },
              },
              {
                name: "Don't Tread On Me",
                symbol: { type: "square" },
              },
            ]}
          />

          {/* Axis */}
          <VictoryChart
            standalone={false}
            padding={{ left: 85 }}
            width={450}
            height={485}
            style={{
              ticks: { stroke: "transparent" },
              tickLabels: { fontSize: 12 },
            }}
          >
            <VictoryBar data={graphData} alignment="start" />
            <VictoryAxis
              dependentAxis
              style={{
                ticks: { stroke: "transparent" },
                tickLabels: { fontSize: 12, fill: "transparent" },
                axis: { stroke: "none" },
              }}
            />
            <VictoryAxis
              crossAxis={false}
              style={{
                tickLabels: { fontSize: 12 },
              }}
            />
          </VictoryChart>

          {/* Bar Chart */}
          <VictoryChart
            horizontal
            standalone={false}
            padding={{ left: 85, top: 15, right: -100 }}
            width={360}
            height={485}
            style={{
              tickLabels: { fontSize: 12 },
            }}
          >
            <VictoryGroup
              offset={12}
              colorScale={[
                "#FF6633", // DTOM
                "#40B5BF", // TC
                "#B3914D", // FTL
                "#FF99FF", // PP
              ]}
            >
              <VictoryBar
                data={dontTreadOnMeData}
                barWidth={270 / barcount - 20}
                cornerRadius={{
                  topLeft: cornerRadius,
                  topRight: cornerRadius,
                }}
              />
              <VictoryBar
                data={toughCookiesData}
                barWidth={270 / barcount - 20}
                cornerRadius={{
                  topLeft: cornerRadius,
                  topRight: cornerRadius,
                }}
              />
              <VictoryBar
                data={forTheLolzData}
                barWidth={270 / barcount - 20}
                cornerRadius={{
                  topLeft: cornerRadius,
                  topRight: cornerRadius,
                }}
              />
              <VictoryBar
                data={peoplePowerData}
                barWidth={270 / barcount - 20}
                cornerRadius={{
                  topLeft: cornerRadius,
                  topRight: cornerRadius,
                }}
              />
            </VictoryGroup>
            <VictoryAxis
              crossAxis={false}
              style={{
                tickLabels: { fontSize: 12 },
              }}
            />
          </VictoryChart>
        </svg>
      </Content>
    </Card>
  );
}
